
let Authentication ={
    session:{},
    IS_LOGGED_IN: false,
    USER_ID: "",
    USERNAME:"",
    FIRST_NAME:"",
    LAST_NAME:"",
    COMPANY_NAME:"",
    setSesion(rdata)
    {
        this.session = rdata;
        this.IS_LOGGED_IN = rdata.is_login;
        this.USER_ID = rdata.user_id;
        this.USERNAME = rdata.user_name;
        this.FIRST_NAME = rdata.first_name;
        this.LAST_NAME = rdata.last_name;
        this.COMPANY_NAME = rdata.company_name;
    }
}

export default Authentication